import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocale } from '@active/react-utils/i18n';
import pubSubInstance from '../../../../../../shared/utils/pubSub';
import { useCreateGooglePayAccountMutation } from '../../../../../../store/services/common/payment/paymentApi';
import { useLogTrackMutation } from '../../../../../../store/services/common/logTrack/logTrackApi';
import { useGooglePayUtilsContext } from './injectGooglePayUtils';

export default function useGooglePay({
  yourPayment,
}) {
  const { i18n } = useLocale();
  const googlePayment = useGooglePayUtilsContext();
  const {
    widgetNameSpace, paymentCountryCode,
  } = useSelector(state => state.propsData);
  const {
    entities: {
      orderInfo: { currencyCode },
    },
  } = useSelector(state => state.mainStateData);
  const {
    entities: {
      paymentMethods: {
        googlePayInfo,
      },
    },
  } = useSelector(state => state.paymentMethods);

  const [ createGooglePayAccount ] = useCreateGooglePayAccountMutation();
  const [ logTrack ] = useLogTrackMutation();

  const handleSubmit = useCallback(() => {
    return new Promise((resolve) => {
      const params = {
        i18n,
        currencyCode,
        yourPayment,
        paymentCountryCode,
        googlePayInfo,
      };
      googlePayment.onGooglePaymentButtonClicked({
        commitCallback: resolve, createGooglePayAccount, params, logTrack,
      });
    });
  }, [ googlePayInfo, paymentCountryCode, currencyCode, googlePayment,
    i18n, createGooglePayAccount, yourPayment, logTrack ]);

  useEffect(() => {
    googlePayment.createGooglePayButton({ widgetNameSpace });
  }, [ widgetNameSpace, googlePayment ]);

  useEffect(() => {
    pubSubInstance.subscribe(`${widgetNameSpace}-payment-item-submit`, handleSubmit);
    return () => {
      pubSubInstance.unsubscribe(`${widgetNameSpace}-payment-item-submit`, handleSubmit);
    };
  }, [ widgetNameSpace, handleSubmit ]);

  useEffect(() => {
    pubSubInstance.subscribe(`${widgetNameSpace}-preview-submit`, handleSubmit);
    return () => {
      pubSubInstance.unsubscribe(`${widgetNameSpace}-preview-submit`, handleSubmit);
    };
  }, [ widgetNameSpace, handleSubmit ]);
}
